import script from "./RestoreAccountView.vue?vue&type=script&setup=true&lang=js"
export * from "./RestoreAccountView.vue?vue&type=script&setup=true&lang=js"

import "./RestoreAccountView.vue?vue&type=style&index=0&id=241c4acc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-241c4acc"]])

export default __exports__